import React from 'react';
import classNames from 'classnames';

export default function Tag(props: {
    children?: React.ReactNode,
    size?: string,
    type?: string,
    className?: string,
    onClick?: () => void
}) {
    let {
        children,
        size = '',
        type = '',
        className = '',
        onClick
    } = props;

    const classes = classNames({
        'tag': true,
        [`is-${size}`]: size.length,
        [`is-${type}`]: type.length,
        [className]: className.length
    });

    return (
        <span className={classes} onClick={onClick}>
            {children}
        </span>
    );
}
